import { register, CloudObject, defineProperty } from 'olympe';

/**
 * @extends {CloudObject}
 */
export default class DocumentationTree extends CloudObject {

    /**
     * Creates an instance of DocumentationTree.
     *
     * @param {!Transaction} transaction
     * @return {!string} the tag of the created instance
     */
    static create(transaction) {
        return transaction.create(DocumentationTree);
    }
    
    /**
     * @return {string}
     */
    getMUIJSONData() {
        return this.get(DocumentationTree.mUIJSONDataProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeMUIJSONData($) {
        return this.observe($, DocumentationTree.mUIJSONDataProp);
    }

    /**
     * @return {string}
     */
    getId() {
        return this.get(DocumentationTree.idProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeId($) {
        return this.observe($, DocumentationTree.idProp);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setMUIJSONData(transaction, instance, value) {
        transaction.update(instance, DocumentationTree.mUIJSONDataProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setId(transaction, instance, value) {
        transaction.update(instance, DocumentationTree.idProp, value);
    }

}

// Hardcoded tags
register('0199865580d501d893e3', DocumentationTree);
DocumentationTree.mUIJSONDataProp = defineProperty('01998664bb5b7496773f');
DocumentationTree.idProp = defineProperty('019994e6735f8dde7e4b');
